import { render, staticRenderFns } from "./DepartmentStatistics.vue?vue&type=template&id=31a53627&scoped=true"
import script from "./DepartmentStatistics.vue?vue&type=script&lang=js"
export * from "./DepartmentStatistics.vue?vue&type=script&lang=js"
import style0 from "./DepartmentStatistics.vue?vue&type=style&index=0&id=31a53627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a53627",
  null
  
)

export default component.exports